import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongDetailsLessonDetails.module.scss";
import {useSongDetailsLessonDetailsLogic} from "./SongDetailsLessonDetails.logic";
import {
  ArrangementPreviewButton
} from "../../../../../../components/songs/song-details-page/arrangement-details/arrangement-preview-button/ArrangementPreviewButton";
import {FontIcon} from "../../../../../../components/common/FontIcon";
import {SongDetailsLessonActions} from "../lesson-actions/SongDetailsLessonActions";
import {LessonPreviewType} from "../../../../../../client/models/songs/LessonPreviewType";

export interface ISongDetailsLessonDetailsProps {
}

export const SongDetailsLessonDetails: VoidFunctionComponent<ISongDetailsLessonDetailsProps> = ({}) => {
  const {lessonId, lessonTitle, previews, showPreviewVideoModalHandler, showPreviewSheetMusicModalHandler, wistiaThumbImgUrl} = useSongDetailsLessonDetailsLogic();

  return (
    <div className={s.lessonDetails}>
      <h2 className={s.title}>{lessonTitle}</h2>
      <SongDetailsLessonActions />
      <div className={s.previewContent}>
        {previews.pianoOnlyAudioUrl || previews.pianoAndBackingTrackAudioUrl ? (
          <div className={s.audioPreviewButtons}>
            {previews.pianoOnlyAudioUrl && <ArrangementPreviewButton label={"Piano Only"} ariaLabel={"Preview with piano only"} audioUrl={previews.pianoOnlyAudioUrl} lessonId={lessonId} previewType={LessonPreviewType.PianoOnly} />}
            {previews.pianoAndBackingTrackAudioUrl && <ArrangementPreviewButton label={"With Backing"} ariaLabel={"Preview with piano and backing track"} audioUrl={previews.pianoAndBackingTrackAudioUrl} lessonId={lessonId} previewType={LessonPreviewType.WithBackingTrack} />}
          </div>
        ): null}
        <div className={s.previewImgs}>
          {(previews.wistiaVideoId && !!wistiaThumbImgUrl)
            ?
            <button className={s.previewButton} onClick={showPreviewVideoModalHandler}>
              <img className={s.previewImg} src={wistiaThumbImgUrl} alt={`Video preview of ${lessonTitle}`} />
              <div className={s.previewIconButton}>
                <FontIcon icon={"icon-play"} />
              </div>
            </button>
            : null}
          {previews.sheetMusicUrl ? (
            <button className={s.previewButton} onClick={showPreviewSheetMusicModalHandler}>
              <img className={s.previewImg} src={previews.sheetMusicUrl} alt={`Sheet music for ${lessonTitle}`} />
              <div className={s.previewIconButton}>
                <FontIcon icon={"icon-search"} />
              </div>
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}

